module.exports = function() {
  return new Worker("./" + "svelte-transpiler.f0c86b74.worker.js");
};